import React, { useState } from "react";
import "./FAQ.css";

const leftColumn = [
  {
    question: "Are the testimonials on your website from real customers?",
    answer:
      "Yes, all our testimonials are from verified Glamur Paint customers who have personally used our products and shared their genuine experiences.",
  },
  {
    question: "How do customers rate Glamur Paint overall?",
    answer:
      "Most of our customers rate Glamur Paint 4.8 out of 5 stars, praising its vibrant finish, durability, smooth texture, and eco-friendly quality.",
  },
];

const rightColumn = [
  {
    question: "Can I submit my own testimonial or feedback?",
    answer:
      "Absolutely! We love hearing from our customers. You can share your experience through our website or social media pages — and your review might be featured on our site.",
  },
  {
    question: "What do professionals say about Glamur Paint?",
    answer:
      "Painters and interior designers choose Glamur Paint for its easy application, superior coverage, and consistent color results, making it a trusted brand for both homes and commercial projects.",
  },
  {
    question: "Do testimonials reflect real results after long-term use?",
    answer:
      "Yes. Many of our featured customers have used Glamur Paint for over a year, and they continue to appreciate its long-lasting beauty, washability, and fade resistance.",
  },
];

const FAQtestimonials = () => {
  // ✅ First FAQ open by default
  const [activeIndex, setActiveIndex] = useState("L0");

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const renderFAQItem = (item, index, columnPrefix) => (
    <div
      key={columnPrefix + index}
      className={`faq-item ${
        activeIndex === columnPrefix + index ? "active" : ""
      }`}
      onClick={() => toggleFAQ(columnPrefix + index)}
    >
      <div className="faq-question">
        <span className="faq-icon">
          {activeIndex === columnPrefix + index ? "–" : "+"}
        </span>
        <h3>{item.question}</h3>
      </div>
      {activeIndex === columnPrefix + index && item.answer && (
        <p className="faq-answer">{item.answer}</p>
      )}
    </div>
  );

  return (
    <section className="faq-section">
      <h2 className="faq-title">Frequently Ask Questions</h2>
      <div className="faq-columns">
        <div className="faq-column">
          {leftColumn.map((item, i) => renderFAQItem(item, i, "L"))}
        </div>
        <div className="faq-column">
          {rightColumn.map((item, i) => renderFAQItem(item, i, "R"))}
        </div>
      </div>
    </section>
  );
};

export default FAQtestimonials;
